<template>
  <div :class="['pt-4', theme.middleScreen.backgroundColor]">
    <div v-if="menuCategories.length > 0">
      <div class="mt-4 flex flex-row mx-4">
        <div :class="['flex w-1/2 lg:w-2/3 justify-begin text-3xl flex-col',theme.body.textColor]">
          <div v-trans:name="selectedMenuCategory"></div>
          <div class="text-xs" v-trans:description="selectedMenuCategory"></div>
      </div>
        <div class="flex w-1/2 lg:w-1/3 justify-end items-center cursor-pointer"><Language/><DisplayMode class="ml-2"/></div>
      </div>
      <div class="flex content-center flex-wrap px-4">
        <div
          v-for="(menuCategory, index) in menuCategories"
          v-bind:key="menuCategory.Id"
          :class="[isListDisplayed ? 'w-full' : 'w-1/2']"
          @click="getCategories(menuCategory)"
        >
          <div class="flex flex-col">
            <div
              :class="[
                'cursor-pointer flex justify-center h-24 rounded items-center my-2 rounded-large shadow-lg transition duration-500  hover:shadow-xl',
                isListDisplayed
                  ? ''
                  : index % 2 == 0
                  ? 'mr-2 flex-col'
                  : 'ml-2 flex-col',
                theme.addToCart.backgroundColor,
                'text-' + theme.body.primaryColor,
              ]"
            >
              <div
                :class="[
                  'flex items-center w-full',
                  menuCategory.picture_url ? 'justify-end' : 'justify-center',
                  isListDisplayed ? 'flex-row' : 'flex-col',
                ]"
              >
                <div
                  v-if="menuCategory.picture_url"
                  class="w-1/2 justify-center flex items-center"
                >
                  <div
                    class="h-16 w-24 rounded-lg overflow-hidden flex items-center"
                  >
                    <img
                      v-if="menuCategory.picture_url"
                      :src="menuCategory.picture_url"
                      alt
                      class="object-fill rounded-lg"
                    />
                  </div>
                </div>
                <div
                  :class="[
                    theme.body.textColor,
                    isListDisplayed
                      ? menuCategory.picture_url
                        ? 'w-1/2'
                        : ''
                      : '',
                  ]"
                  v-trans:name="menuCategory"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DisplayMode from "../views/DisplayMode";
import Language from "../views/Language";
import lang from "../lang";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  name: "Home",
  components: { DisplayMode,Language },
  computed: mapGetters([
    "language",
    "menuCategories",
    "menuSubCategories",
    "selectedMenuCategory",
    "isListDisplayed",
    "theme",
    "menu",
  ]),
  created() {
    sessionStorage.removeItem("orderChunksExists");
    sessionStorage.setItem(
      "sessionId",
      [...Array(30)].map(() => Math.random().toString(36)[2]).join("")
    );
  },
  mounted() {
    /** Update table ID if exists. */
    if (this.$route.params.tableId) {
      this.$store.dispatch("Cart/GET_TABLES").then((response) => {
        let tableObject = this.$_.findLast(response.data, (item) => {
          return item.stickerId == this.$route.params.tableId;
        });
        /** If valid StickerId, then update the table ID else keep it 0 (zero) */
        if (tableObject) {
          localStorage.setItem("stickerId", tableObject.stickerId);
          this.$store.commit("Cart/updateTableId", parseInt(tableObject.Id));
        } else {
          
          this.$store.commit("Cart/updateTableId", '0');
          
        }
      });
    } else {
      this.$store.commit("Cart/updateTableId", 0);
      localStorage.setItem("stickerId", '0');
    }
    this.$store.commit("updateMenuSubCategories", []);
  },
  methods: {
    getCategories(item) {
      this.$store.commit("updateSelectedMenuCategory", item);
      this.$store.commit("updateCategoryId", item.Id);
      if (item.hasSubCategories) {
        this.$store.commit("updateSubCategoryId", item.Id);
        this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
        this.$store.commit("updateMenuCategoriesCategories", item);

        this.$router.push(
          "/" + this.$route.params.menuHash + "/category/" + item.Id
        ).catch(()=>{});
      } else {
        this.$store.dispatch("GET_CATEGORY");
        this.$router.push(
          "/" + this.$route.params.menuHash + "/sub/category/" + item.Id
        ).catch(()=>{});
      }
    },
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>